import styled from "styled-components";

import Colors from "colors";

export default styled.div`
  padding: 3vw 6vw 3vw 6vw;

  .tag {
    margin-right: 10px;
  }

  .box {
    .jobInfo {
      .regionalRestrictions {
        margin-top: 10px;
      }
    }
    .divider {
      position: relative;
      color: ${Colors.grayDark};
      margin: 0 10px 0 10px;
      top: -1px;
    }
    .description {
      margin-top: 20px;
    }
  }

  .company {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .name {
      color: black;
    }
    .info {
      .textIcon {
        color: #919191;
      }
      font-size: 13px;
      margin-top: 5px;
    }
    .jobs {
      color: ${Colors.red};
      cursor: pointer;
      font-size: 14px;
      margin-top: 20px;
    }
    .companyLogo {
      height: auto;
      margin-bottom: 10px;
    }
  }

  .contact {
    text-align: center;
    button {
      margin-top: 10px;
    }
  }
`;
